/**
 * The browser's view of the arb rule. The rule itself lives in arbCore.js, which the server requires
 * unchanged — this file only adds what the grid needs and nothing the server would care about.
 */
import {
  isSoftRow,
  isSharpRow,
  displayBookmaker,
  findSoftRow,
  findSharpRow,
  findArbs,
  eventHasArb,
  arbKey
} from './arbCore'

export { isSoftRow, isSharpRow, displayBookmaker, findSoftRow, findSharpRow, findArbs, eventHasArb, arbKey }

/**
 * `${bookmaker}|${field}` of every price that takes part in an arb, mapped to the index of that arb, so
 * the two sides of one opportunity get the same shade and a second opportunity gets a different one.
 */
export const buildArbCellIndex = (event, minProfit) => {
  const index = new Map()
  findArbs(event, minProfit).forEach((arb, arbIndex) => {
    arb.legs.forEach((leg) => {
      index.set(`${leg.bookmaker}|${leg.field}`, { arbIndex, profit: arb.profit, market: arb.market })
    })
  })
  return index
}
